/* eslint-disable max-len */
import React, {useState} from 'react';
import styled, {css} from 'styled-components';

import {colors, mobileMediaQuery, tabletMediaQuery} from './../../styles';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const TabsContent = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding-top: 3rem;
    padding-bottom: 3rem;

    ${({empty}) =>
        empty
            ? css`
                  ${tabletMediaQuery} {
                      padding: 72px 24px 0px 24px;
                  }

                  ${mobileMediaQuery} {
                      padding: 65px 18px 0px 26px;
                  }
              `
            : css`
                  ${tabletMediaQuery} {
                      padding: 24px 0 0 0;
                  }

                  ${mobileMediaQuery} {
                      padding: 28px 0 0 0;
                  }
              `}
`;

const Navigation = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 56px;
    ${({tabColor}) => tabColor && `background-color: ${tabColor}`};
`;

const NavigationButton = styled.button`
    background-color: transparent;
    border: 0;
    border-radius: 0px;
    height: 100%;
    width: auto;
    font-size: 18px;
    line-height: 30px;
    padding: 8px 0 0 0;

    margin: 0 2rem;
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    color: white;
    text-transform: uppercase;

    ${({active}) =>
        active &&
        css`
            font-weight: bold;
            border-bottom: 3px solid transparent;
            border-image: linear-gradient(
                90deg,
                #00aeef 0%,
                #ffd93f 32.81%,
                #ffd93f 68.75%,
                #ec008c 100%
            );
            border-image-slice: 1;
        `};

    ${mobileMediaQuery} {
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 1.19px;
        margin: 0px;
        border-bottom: 4px solid transparent;

        ${({active}) =>
            active &&
            css`
                border-color: ${colors.pink};
            `};

        :not(:last-of-type) {
            margin-right: 40px;
        }
    }
`;

const Tabs = ({items, ...props}) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleSelectTab = index => {
        setActiveTab(index);
    };

    return (
        <Container {...props}>
            <Navigation tabColor={props.tabColor}>
                {items.map((item, index) => {
                    return (
                        <NavigationButton
                            key={`key${index + 1}`}
                            onClick={e => handleSelectTab(index)}
                            active={index === activeTab}
                        >
                            {item.title}
                        </NavigationButton>
                    );
                })}
            </Navigation>

            <TabsContent
                empty={
                    !items[activeTab] || items[activeTab].content.length === 0
                }
            >
                {items[activeTab] && items[activeTab].content}
            </TabsContent>
        </Container>
    );
};

export default Tabs;
